import "./navbar.scss";
import React, { FunctionComponent } from "react";
import Logo from "../../assets/images/logos/trk-logo.png";
import { useAppSelector } from "../../features/helpers";
import { UserInfo } from "../../store/UserSlice";
import SkeletonLine from "../skeleton/SkeletonLine";

const Navbar: FunctionComponent = () => {

  const userInfo : UserInfo = useAppSelector( (state) => state.user.userInfo );

  const initial = (userInfo?.name?.trim()?.[0] ?? "?").toUpperCase();
  const orgName = userInfo?.organizationUsers?.[0]?.organization?.organizationName;

  return (
    <div className="navbar">

      <div className="brand">
        <div className="brand-mark">
          <img src={Logo} alt="Tabletop" />
        </div>
        <span className="brand-name">TABLETOP</span>
      </div>

      <div className="user-info">
        {userInfo && userInfo.organizationUsers ? (
          <>
            <div className="user-avatar" aria-hidden="true">{initial}</div>
            <div className="user-text">
              <span className="user-name">{userInfo.name}</span>
              <span className="user-meta">
                <span className="role-pill">{userInfo.role}</span>
                {orgName && <span className="org">{orgName}</span>}
              </span>
              <span className="user-email">{userInfo.email}</span>
            </div>
          </>
        ) : (
          <>
            <div className="user-avatar skeleton" aria-hidden="true" />
            <div className="user-text">
              <SkeletonLine height="10" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Navbar;